import { useMemo } from 'react';
import { useImage } from '@24i/nxg-sdk-gluons/src/context/ImageService';
import useAssetActions from '@24i/nxg-sdk-smartott/src/hooks/useAssetActions';
import { ViewModelReturnType } from '../View/types';

function useViewModel<P extends { section: any }>(props: P): ViewModelReturnType<P> {
    const { getActionIcon } = useAssetActions();
    const { getImagesByOrientation } = useImage();

    const updatedSection = useMemo(
        () => ({
            ...props.section,
            additionalItems: getImagesByOrientation(
                props.section.additionalItems,
                props.section.display
            ),
        }),
        [props.section]
    );

    return {
        ...props,
        section: updatedSection,
        getActionIcon,
    };
}

export { useViewModel };
